import { z } from "zod";

/**
 * Embed public endpoint schemas.
 *
 * GET /api/deployments/embed/:id/public now returns DeploymentResponse (see ZDeployments.GetEmbedPublicInfo).
 * This file keeps path vars and the shared agent shape used by DeploymentResponseSchema.
 */

// ============================================================================
// PATH VARIABLES
// ============================================================================

export const GetEmbedPublicInfoPathVarsSchema = z.object({
  id: z.string().uuid()
});

// ============================================================================
// AGENT – used by DeploymentResponseSchema
// ============================================================================

export const EmbedAgentSchema = z.object({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  profile_picture: z.string().nullable(),
  role: z.string().nullable(),
  details: z.string().nullable()
});

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type GetEmbedPublicInfoPathVars = z.infer<typeof GetEmbedPublicInfoPathVarsSchema>;
export type EmbedAgent = z.infer<typeof EmbedAgentSchema>;
